import React from 'react';

// interface
import { InfocenterModuleProps, ILinkProps } from '../../../interfaces/interfaces';

// module, source
import Header from '../../elements/Header/Header';
import Link from '../../elements/Link/Link';
import TileWrapper from '../../elements/TileWrapper/TileWrapper';

function InfocenterModule(props: InfocenterModuleProps & ILinkProps): JSX.Element {
  const {
    headline,
    textContent,
    phone,
    phoneHref,
    phoneAriaLabel,
    noticeCost,
    serviceTime,
    linkText,
    linkHref,
    tileId,
    isEditable,
    hideMenu,
    dataAttributes,
  } = props;

  return (
    <div className="tile-body">
      {headline ? <Header headline={headline} tileId={tileId} hideMenu={hideMenu} isEditable={isEditable} /> : ''}

      <TileWrapper className="tile-padding" clickable={false}>
        {/* eslint-disable-next-line react/no-danger */}
        <h5 className="hl-5" dangerouslySetInnerHTML={{ __html: textContent }} />
        <h3 className="hl-3">
          <a href={`tel:${phoneHref}`} className="link phoneNumber" aria-label={phoneAriaLabel}>
            {phone}
          </a>
        </h3>
        <p className="tx_2">{noticeCost}</p>
        <p className="tx_2 time">{serviceTime}</p>

        <Link
          linkHref={linkHref}
          linkText={linkText}
          dataAttributes={dataAttributes}
          linkClass="multiple-link tile-link link ic-arrowRight"
          linkTextClass="link-text"
        />
      </TileWrapper>
    </div>
  );
}
export default InfocenterModule;
